import React, { Fragment } from 'react';
import { observer } from 'mobx-react';

import view from 'modules/ticketPublicPage/stores/vouchers/view';
import form from 'modules/ticketPublicPage/stores/vouchers/form';
import config from '../../../config';

import {
  ORDERBIRD_PRIVACY_POLICY_URL,
  ORDERBIRD_TERMS_CONDITIONS_URL,
  RESMIO_PRIVACY_POLICY_URL,
  RESMIO_TERMS_CONDITIONS_B2C_URL,
} from 'app/constants';
import { colors } from 'app/variables';
import Button from 'app/commonComponents/Button';
import ResmioIcon from 'app/commonComponents/icons/ResmioIcon';
import OrderbirdIcon from 'app/commonComponents/icons/OrderbirdIcon';
import { Actions, PrivacyNotice } from './Action.styles';

const Action = observer(() => {
  const {
    showBackButton,
    onBackBtnClick,
    onNextBtnClick,
    step,
    disableSaveButton,
    PAYMENT_DETAILS,
    INITIAL,
    CONFIRMATION,
    hideBuyButton,
    isSavingPayment,
  } = form;
  const { activeObject } = view;

  const handleLogoClick = () => {
    const url = config.isOrderbirdFacility
      ? 'https://orderbird.com'
      : 'https://resmio.com';
    window.open(url);
  };

  const privacyText = i18n.sprintf(
    i18n.gettext(
      'By clicking the "Buy" button you agree to the <a target="_blank" href="%s" rel="nofollow">Terms & Conditions</a> and <a target="_blank" href="%s" rel="nofollow">Privacy Policy</a>'
    ),
    config.isOrderbirdFacility
      ? ORDERBIRD_TERMS_CONDITIONS_URL
      : RESMIO_TERMS_CONDITIONS_B2C_URL,
    config.isOrderbirdFacility
      ? ORDERBIRD_PRIVACY_POLICY_URL
      : RESMIO_PRIVACY_POLICY_URL
  );

  return (
    <Actions>
      {step === PAYMENT_DETAILS ? (
        <PrivacyNotice dangerouslySetInnerHTML={{ __html: privacyText }} />
      ) : null}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {showBackButton ? (
          <Button
            color={colors.pacificBlue}
            onClick={onBackBtnClick}
            disabled={isSavingPayment}
            hollow={true}
          >
            {i18n.gettext('Back')}
          </Button>
        ) : step === INITIAL && config.isOrderbirdFacility ? (
          <OrderbirdIcon
            onClick={handleLogoClick}
            style={{ width: '7rem', cursor: 'pointer' }}
            role="link"
            aria-label={i18n.gettext('Orderbird')}
          />
        ) : step !== CONFIRMATION ? (
          <ResmioIcon
            onClick={handleLogoClick}
            style={{ width: '7rem', cursor: 'pointer' }}
            role="link"
            aria-label={i18n.gettext('Resmio')}
          />
        ) : null}
        {!hideBuyButton && activeObject.status === 'active' ? (
          <Button
            color={colors.pacificBlue}
            onClick={onNextBtnClick}
            disabled={disableSaveButton}
          >
            {step === PAYMENT_DETAILS
              ? i18n.gettext('Buy')
              : i18n.gettext('Next')}
          </Button>
        ) : null}
        {step === CONFIRMATION ? (
          <Button
            onClick={onNextBtnClick}
            color={colors.pacificBlue}
            style={{
              margin: '1rem auto',
              alignSelf: 'center',
              padding: '0.75rem 4rem',
              width: '90%',
            }}
          >
            {i18n.gettext('Buy another voucher')}
          </Button>
        ) : null}
      </div>
    </Actions>
  );
});

export default Action;
